module.exports = __webpack_public_path__ + "static/media/scroll02_0_2x.762dd1f8.png";